var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(this.sale)?_c('sale-form',{staticClass:"mb-5 pa-2",attrs:{"model":this.sale},on:{"saved":_vm.saved}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }